import * as React from "react";
import Container from "../../common/Container";
import { Table } from "antdv5";

interface IData {
  rank: number;
  DeviceName: string;
  DeviceCount: string;
  DeviceUUID: string;
}
const columns = [
  {
    title: "序号",
    dataIndex: "rank",
    width: 70,
    sorter: (a: IData, b: IData) => a.rank - b.rank,
  },
  {
    title: "踏板名称",
    dataIndex: "DeviceName",
    width: 100,
    sorter: {
      compare: (a: IData, b: IData) =>
        parseInt(a.DeviceName) - parseInt(b.DeviceName),
      multiple: 3,
    },
  },
  {
    title: "扫描次数",
    dataIndex: "DeviceCount",
    width: 100,
    sorter: {
      compare: (a: IData, b: IData) =>
        parseInt(a.DeviceCount) - parseInt(b.DeviceCount),
      multiple: 3,
    },
  },
  {
    title: "踏板ID",
    dataIndex: "DeviceUUID",
    width: 180,
    sorter: (a: IData, b: IData) => a.DeviceUUID.localeCompare(b.DeviceUUID),
  },
];

interface IProps {
  hint: string;
  searchDevice: string;
  data: IData[];
  loading: boolean;
  noActionID: number;
}

const DailyTotalTable = ({
  hint,
  searchDevice,
  data,
  loading,
  noActionID,
}: IProps) => {
  return (
    <Container>
      <div className="hint">搜索日期范围：{hint}</div>
      <div className="hint">搜索编号：{searchDevice}</div>
      <Table
        className="bordered-table"
        columns={columns}
        dataSource={data}
        pagination={false}
        scroll={{ x: "max-content" }}
        rowKey="DeviceUUID"
        loading={loading}
        sticky
        size={"small"}
        bordered
        summary={() => {
          let allTotal = 0;
          data &&
            data.forEach((elem) => {
              allTotal += Number(elem.DeviceCount);
            });
          return (
            <Table.Summary fixed>
              <Table.Summary.Row className="no-border">
                <Table.Summary.Cell colSpan={2} index={0}>
                  扫描总计次数
                </Table.Summary.Cell>
                <Table.Summary.Cell colSpan={2} index={1}>
                  {allTotal}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          );
        }}
      />
      <p className="noActionID">无踏板编号扫描次数：{noActionID} 次</p>
    </Container>
  );
};

export default DailyTotalTable;
